import React, { useEffect } from 'react';

import Logo from '../components/common/Logo';
import { pwaRoutes } from '../utilities/pwaRoutes';

export function SignupPage() {
	useEffect(() => {
		window.location.assign(pwaRoutes.signup());
	}, []);

	return (
		<div className="mx-auto flex min-h-full w-full min-w-0 max-w-sm flex-col items-center gap-6 px-4 py-8 text-center sm:px-6 sm:py-12">
			<Logo className="mb-4 px-4 sm:px-6" />
			<div className="w-full min-w-0 rounded-xl border border-border bg-card p-5 shadow-sm sm:p-6">
				<h1 className="break-words text-xl font-medium text-foreground">Redirecting to sign up...</h1>
			</div>
		</div>
	);
}
